<template>
  <v-dialog
    v-model="abrirModal"
    :max-width="maxWidth"
    :width="width"
    persistent
  >
    <v-card class="rounded-xxl">
      <v-card-title class="d-flex justify-end">
        <v-btn icon @click="dialogCerrar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="d-flex flex-column align-center">
          <p class="title text-center">{{ titulo }}</p>
          <p class="message text-center my-2">{{ mensaje }}</p>
        </div>
        <div style="max-height: 400px; overflow-y: auto; padding-bottom: 20px">
          <AppDataTableComponent
            :dataConfig="dataConfig"
            :pagination="pagination"
            :items-per-page="
              pagination ? itemsPerPage : dataConfig?.items?.length
            "
            :total-pages="totalPages"
            :total-registros="totalRegistros"
            :current-page="currentPage"
            :correlativo="false"
            tableClass="elevation-4 rounded-xl striped-rows pb-4"
            class="mx-md-10 mt-8"
            @paginationChange="emitPaginationChange"
            @perPageChange="emitPerPageChange"
          >
          </AppDataTableComponent>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-col class="d-flex flex-column flex-sm-row justify-center">
          <v-btn
            color="btnAzul"
            outlined
            style="text-transform: none"
            @click="dialogCerrar"
            rounded
          >
            Cerrar
          </v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AppDataTableComponent from '@/components/AppDataTableComponent.vue';
export default {
  name: 'AppUploadDialogErrors',
  components: { AppDataTableComponent },
  props: {
    abrirModal: {
      type: Boolean,
      default: false,
    },
    titulo: {
      type: String,
      required: false,
      default: 'Inconsistencias encontradas',
    },
    mensaje: {
      type: String,
      required: false,
      default: 'Los siguientes registros no se pudieron cargar',
    },
    dataConfig: {
      type: Object,
      required: true,
    },
    maxWidth: {
      type: [String, Number],
      required: false,
      default: 800,
    },
    width: {
      type: [String, Number],
      required: false,
      default: undefined,
    },
    pagination: {
      type: Boolean,
      required: false,
      default: false,
    },
    itemsPerPage: {
      type: Number,
      required: false,
      default: 10,
    },
    totalPages: {
      type: Number,
      required: false,
      default: 1,
    },
    totalRegistros: {
      type: Number,
      required: false,
      default: null,
    },
    currentPage: {
      type: Number,
      required: false,
      default: 1,
    },
  },
  data() {
    return {};
  },
  methods: {
    dialogCerrar() {
      this.$emit('dialogCerrar');
    },
    emitPaginationChange(page) {
      this.$emit('paginationChange', page);
    },
    emitPerPageChange(perPage) {
      this.$emit('perPageChange', perPage);
    },
  },
};
</script>

<style scoped>
.title {
  font-size: 30px !important;
  color: #1c1e4d !important;
  font-weight: bold;
}

.message {
  font-size: 20px !important;
  color: gray !important;
}

:deep(.v-dialog) {
  box-shadow: none;
}

.rounded-xxl {
  border-radius: 50px !important;
}

:deep(
    .theme--light.v-data-table
      > .v-data-table__wrapper
      > table
      > thead
      > tr:last-child
      > th.sortable
  ) {
  text-align: start !important;
  font-weight: bold !important;
  font-size: 14px !important;
}
</style>
